import React, { useEffect, useRef, useState } from "react";
import Table from "../../core/common/dataTable/index";
import Select from "react-select";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import { manageusersData } from "../../core/data/json/manageuser";
import CollapseHeader from "../../core/common/collapse-header";
import {
  createUser,
  deleteUser,
  fetchAllUsers,
  updateUser,
  User,
} from "../../api/usermanager";
import { toast } from "react-toastify";
import { fetchClients, Client } from "../../api/client";
import { API_BASE_PATH } from "../../environment";
import axios from "axios";
import { highlightMatch } from "../../core/common/highlightmatch";
import { initialSettings } from "../../core/common/selectoption/selectoption";

const Manageusers = () => {
  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
  });
  const [clients, setClients] = useState<Client[]>([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortOption, setSortOption] = useState("recently_added");
  const [selectedDateRange, setSelectedDateRange] = useState<
    [Date, Date] | null
  >(null);
  const [activeRangeLabel, setActiveRangeLabel] = useState<string>("");
  const [filteredUsers, setFilteredUsers] = useState<User[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const togglePasswordVisibility = (field: "password") => {
    setPasswordVisibility((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };
  const [loading, setLoading] = useState<boolean>(true);
  const [showAdd, setShowAdd] = useState(false);
const [showEdit, setShowEdit] = useState(false);
  const [editUserData, setEditUserData] = useState({
    role: "",
    photo: null as File | null,
  });
  const [formData, setFormData] = useState<User>({
    name: "",
    email: "",
    phone_no: "",
    role: "",
    created_at: "",
    status: true,
    organisation_id: "",
    client_id: "", // <-- Add this!
    password: "",
    photo: null,
  });
  useEffect(() => {
    const getClients = async () => {
      try {
        const clientList = await fetchClients();
        setClients(clientList);
      } catch (error) {
        console.error("Failed to fetch clients", error);
      }
    };

    getClients();
  }, []);
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setFormData((prev) => ({ ...prev, photo: e.target.files![0] }));
    }
  };

  const handleStatusChange = (status: boolean) => {
    setFormData((prev) => ({ ...prev, status }));
  };

  const handleCreate = async () => {
    const token = localStorage.getItem("token") || "";

    if (
      !formData.name ||
      !formData.email ||
      !formData.password ||
      !formData.phone_no ||
      !formData.role
    ) {
      toast.error("Please fill all required fields");
      return;
    }

    try {
      const newUser: User = {
        name: formData.name,
        email: formData.email,
        phone_no: formData.phone_no,
        role: formData.role,
        status: formData.status,
        password: formData.password,
        organisation_id: formData.organisation_id,
        client_id: formData.client_id,
        is_deleted: false,
        photo: formData.photo || null,
      };

      await createUser(newUser, token);

      toast.success("User created successfully!");

      // ✅ Refresh list after creation
      await refreshUsers();

      // ✅ Reset form
      setFormData({
        name: "",
        email: "",
        phone_no: "",
        role: "",
        status: true,
        password: "",
        organisation_id: "",
        client_id: "",
        photo: null,
      });

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    } catch (error) {
      console.error(error);
      console.error("Failed to create user");
    }
  };

  const handleFileChangeEdit = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setEditUserData((prev) => ({ ...prev, photo: e.target.files![0] }));
    }
  };
  const handleInputChangeEdit = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setEditUserData((prev) => ({ ...prev, [name]: value }));
  };

  const [visibleColumns, setVisibleColumns] = useState<string[]>([
    "Name",
    "Phone",
    "Email",
    "Role",
    "Client",
    "Created",
    "Last Activity",
    "Status",
    "Action",
  ]);

  const [users, setUsers] = useState<User[]>([]);
  const [selectedUserId, setSelectedUserId] = useState<string | null>(null);

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);

      try {
        const token = localStorage.getItem("token") || "";
        const userList = await fetchAllUsers(token);
        setUsers(userList);
      } catch (err) {
        console.error("Failed to fetch users", err);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);
  const handleUpdateUser = async () => {
    const token = localStorage.getItem("token") || "";

    if (!selectedUserId) {
      toast.error("No user selected for update.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("role", editUserData.role);
      if (editUserData.photo) {
        formData.append("photo", editUserData.photo);
      }

      await axios.put(
        `${API_BASE_PATH}/user/${selectedUserId}/update-role`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
          },
        }
      );

      // Refresh user list
      const updatedUsers = await fetchAllUsers(token);
      setUsers(updatedUsers);

      toast.success("User updated successfully!");
    } catch (error) {
      console.error("Error updating user:", error);
      console.error("Failed to update user.");
    }
  };

  const handleDelete = async () => {
    if (!selectedUserId) return;
    try {
      await deleteUser(selectedUserId);
      refreshUsers();
    } catch (err) {
      console.error("Delete failed", err);
      console.error("Failed to delete user");
    }
  };

  const refreshUsers = async () => {
    try {
      const token = localStorage.getItem("token") || "";
      const data = await fetchAllUsers(token);
      setUsers(data);
    } catch (error) {
      console.error("Error refreshing users", error);
    }
  };

  const [passwords, setPasswords] = useState([false, false]);

  const togglePassword = (index: any) => {
    const updatedPasswords = [...passwords];
    updatedPasswords[index] = !updatedPasswords[index];
    setPasswords(updatedPasswords);
  };
  const [stars, setStars] = useState<{ [key: number]: boolean }>({});

  const initializeStarsState = () => {
    const starsState: { [key: number]: boolean } = {};
    manageusersData.forEach((item, index) => {
      starsState[index] = false;
    });
    setStars(starsState);
  };

  React.useEffect(() => {
    initializeStarsState();
  }, []);

  const allColumns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (text: string, record: User) => (
        <div className="d-flex align-items-center">
          <div className="d-flex flex-column">
            <span className="fw-bold">
              {highlightMatch(record.name, searchQuery)}
            </span>
            <span className="text-muted small">
              {highlightMatch(record.email, searchQuery)}
            </span>
          </div>
        </div>
      ),
    },
    {
      title: "Phone",
      dataIndex: "phone_no",
      render: (text: string) => highlightMatch(text || "-", searchQuery),
    },
    {
      title: "Email",
      dataIndex: "email",
      render: (text: string) => highlightMatch(text || "-", searchQuery),
    },
    {
      title: "Role",
      dataIndex: "role",
      render: (text: string) => highlightMatch(text || "-", searchQuery),
    },
    {
      title: "Client",
      dataIndex: "client_name",
      render: (text: string | undefined) =>
        highlightMatch(text || "N/A", searchQuery),
    },
    {
      title: "Created",
      dataIndex: "created_at",
      render: (date: string) =>
        date ? new Date(date).toLocaleDateString() : "-",
    },
    {
      title: "Last Activity",
      dataIndex: "last_activity",
      render: (value: string) => {
        const parsed = new Date(value);
        return isNaN(parsed.getTime()) ? value : parsed.toLocaleDateString();
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status: boolean) => (
        <span
          className={`badge badge-pill ${status ? "bg-success" : "bg-danger"}`}
        >
          {status ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_: any, record: any) => (
        <div className="dropdown table-action">
          <Link
            to="#"
            className="action-icon"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" />
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              className="dropdown-item"
              to="#"
              onClick={(e) => {
          e.preventDefault();
          setSelectedUserId(record.id || null);
          setEditUserData({
            role: record.role || "",
            photo: null,
          });
          setShowEdit(true);
        }}
            >
              <i className="ti ti-edit text-primary" /> Edit
            </Link>
            <Link
              className="dropdown-item"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#delete_contact"
              onClick={() => setSelectedUserId(record.id || null)}
            >
              <i className="ti ti-trash text-danger" /> Delete
            </Link>
          </div>
        </div>
      ),
    },
  ];
  const handleToggleColumn = (columnName: string) => {
    setVisibleColumns((prev) =>
      prev.includes(columnName)
        ? prev.filter((col) => col !== columnName)
        : [...prev, columnName]
    );
  };
  const columns = allColumns.filter((col) =>
    visibleColumns.includes(col.title)
  );

  // 🧠 Search + Sort + Date Filter
  useEffect(() => {
    let updated = [...users]; // Assume 'users' is your raw user data
    const query = searchQuery.trim().toLowerCase();

    // 🔍 Search
    if (query) {
      updated = updated.filter((user) =>
        [
          user.name,
          user.email,
          user.phone_no,
          user.role,
          user.client_name,
        ].some((field) => field?.toLowerCase().includes(query))
      );
    }

    // 📅 Date Range Filter
    if (selectedDateRange) {
      const [start, end] = selectedDateRange;
      updated = updated.filter((user) => {
        const created = user.created_at
          ? new Date(user.created_at).getTime()
          : null;
        return (
          created && created >= start.getTime() && created <= end.getTime()
        );
      });
    }

    // 🔽 Sorting
    switch (sortOption) {
      case "ascending":
        updated.sort((a, b) => a.name.localeCompare(b.name));
        break;
      case "descending":
        updated.sort((a, b) => b.name.localeCompare(a.name));
        break;
      case "recently_added":
        updated.sort(
          (a, b) =>
            new Date(b.created_at ?? "").getTime() -
            new Date(a.created_at ?? "").getTime()
        );
        break;
      case "recently_viewed":
        updated.sort(
          (a, b) =>
            new Date(b.last_activity ?? "").getTime() -
            new Date(a.last_activity ?? "").getTime()
        );
        break;
      default:
        break;
    }

    setFilteredUsers(updated);
  }, [searchQuery, sortOption, selectedDateRange, users]);
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-8">
                    <h4 className="page-title"><i className="bi bi-person-gear text-primary me-2"/>Manage Users</h4>
                    {/* User<span className="count-title"></span> */}
                  </div>
                  <div className="col-4 text-end">
                    <div className="head-icons">
                      <CollapseHeader />
                    </div>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
              <div className="card">
                <div className="card-header">
                  {/* Search */}
                  <div className="row align-items-center">
                    <div className="col-sm-4">
                      <div className="icon-form mb-3 mb-sm-0">
                        <span className="form-icon">
                          <i className="ti ti-search" />
                        </span>
                        <input
                          type="text"
                          className="form-control w-auto"
                          placeholder="Search User"
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-sm-8">
                      <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                        <div className="dropdown me-2">
                          {/* <Link
                            to="#"
                            className="dropdown-toggle"
                            data-bs-toggle="dropdown"
                          >
                            <i className="ti ti-package-export me-2" />
                            Export
                          </Link> */}
                          <div className="dropdown-menu  dropdown-menu-end">
                            <ul>
                              {/* <li>
                                <Link to="#" className="dropdown-item">
                                  <i className="ti ti-file-type-pdf text-danger me-1" />
                                  Export as PDF
                                </Link>
                              </li>
                              <li>
                                <Link to="#" className="dropdown-item">
                                  <i className="ti ti-file-type-xls text-green me-1" />
                                  Export as Excel{" "}
                                </Link>
                              </li> */}
                            </ul>
                          </div>
                        </div>
                        <Link
  to="#"
  className="btn btn-primary"
  onClick={() => setShowAdd(true)}
>
  <i className="ti ti-square-rounded-plus me-2" />
  Add User
</Link>
                      </div>
                    </div>
                  </div>
                  {/* /Search */}
                </div>
                <div className="card-body">
                  {/* Filter */}
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-4">
                    <div className="d-flex align-items-center flex-wrap row-gap-2">
                      <div className="dropdown me-2">
                        <Link
                          to="#"
                          className="dropdown-toggle"
                          data-bs-toggle="dropdown"
                        >
                          <i className="ti ti-sort-ascending-2 me-2" />
                          Sort
                        </Link>
                        <div className="dropdown-menu dropdown-menu-start">
                          <ul>
                            {[
                              { label: "Ascending", value: "ascending" },
                              { label: "Descending", value: "descending" },
                              {
                                label: "Recently Added",
                                value: "recently_added",
                              },
                              {
                                label: "Recently Viewed",
                                value: "recently_viewed",
                              },
                            ].map(({ label, value }) => {
                              const isActive = sortOption === value;
                              return (
                                <li key={value}>
                                  <Link
                                    to="#"
                                    className={`dropdown-item d-flex justify-content-between align-items-center ${
                                      isActive ? "fw-bold text-primary" : ""
                                    }`}
                                    onClick={() => setSortOption(value)}
                                  >
                                    <span>
                                      <i className="ti ti-circle-chevron-right me-1" />
                                      {label}
                                    </span>
                                    {isActive && <i className="ti ti-check" />}
                                  </Link>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </div>

                      <div className="icon-form">
                        <span className="form-icon">
                          <i className="ti ti-calendar" />
                        </span>
                        <DateRangePicker
                          initialSettings={initialSettings}
                          onCallback={(start, end, label) => {
                            setSelectedDateRange([
                              start.toDate(),
                              end.toDate(),
                            ]);
                            if (label) setActiveRangeLabel(label);
                          }}
                        >
                          <input
                            className="form-control bookingrange"
                            type="text"
                            readOnly
                          />
                        </DateRangePicker>
                      </div>
                    </div>
                    <div className="d-flex align-items-center flex-wrap row-gap-2">
                      <div className="dropdown me-2">
                        <Link
                          to="#"
                          className="btn bg-soft-purple text-purple"
                          data-bs-toggle="dropdown"
                          data-bs-auto-close="outside"
                        >
                          <i className="ti ti-columns-3 me-2" />
                          Manage Columns
                        </Link>
                        <div className="dropdown-menu  dropdown-menu-md-end dropdown-md p-3">
                          <h4 className="mb-2 fw-semibold">
                            Want to manage datatables?
                          </h4>
                          <p className="mb-3">
                            Please drag and drop your column to reorder your
                            table and enable see option as you want.
                          </p>
                          <div className="border-top pt-3">
                            <div className="d-flex align-items-center justify-content-between mb-3">
                              <p className="mb-0 d-flex align-items-center">
                                <i className="ti ti-grip-vertical me-2" />
                                Name
                              </p>
                              <div className="status-toggle">
                                <input
                                  type="checkbox"
                                  id="col-name"
                                  className="check"
                                  checked={visibleColumns.includes("Name")}
                                  onChange={() => handleToggleColumn("Name")}
                                />
                                <label
                                  htmlFor="col-name"
                                  className="checktoggle"
                                ></label>
                              </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between mb-3">
                              <p className="mb-0 d-flex align-items-center">
                                <i className="ti ti-grip-vertical me-2" />
                                Phone
                              </p>
                              <div className="status-toggle">
                                <input
                                  type="checkbox"
                                  id="col-phone"
                                  className="check"
                                  checked={visibleColumns.includes("Phone")}
                                  onChange={() => handleToggleColumn("Phone")}
                                />
                                <label
                                  htmlFor="col-phone"
                                  className="checktoggle"
                                ></label>
                              </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between mb-3">
                              <p className="mb-0 d-flex align-items-center">
                                <i className="ti ti-grip-vertical me-2" />
                                Email
                              </p>
                              <div className="status-toggle">
                                <input
                                  type="checkbox"
                                  id="col-email"
                                  className="check"
                                  checked={visibleColumns.includes("Email")}
                                  onChange={() => handleToggleColumn("Email")}
                                />
                                <label
                                  htmlFor="col-email"
                                  className="checktoggle"
                                ></label>
                              </div>
                            </div>

                            <div className="d-flex align-items-center justify-content-between mb-3">
                              <p className="mb-0 d-flex align-items-center">
                                <i className="ti ti-grip-vertical me-2" />
                                Role
                              </p>
                              <div className="status-toggle">
                                <input
                                  type="checkbox"
                                  id="col-role"
                                  className="check"
                                  checked={visibleColumns.includes("Role")}
                                  onChange={() => handleToggleColumn("Role")}
                                />
                                <label
                                  htmlFor="col-role"
                                  className="checktoggle"
                                ></label>
                              </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between mb-3">
                              <p className="mb-0 d-flex align-items-center">
                                <i className="ti ti-grip-vertical me-2" />
                                Client
                              </p>
                              <div className="status-toggle">
                                <input
                                  type="checkbox"
                                  id="col-client"
                                  className="check"
                                  checked={visibleColumns.includes("Client")}
                                  onChange={() => handleToggleColumn("Client")}
                                />
                                <label
                                  htmlFor="col-client"
                                  className="checktoggle"
                                ></label>
                              </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between mb-3">
                              <p className="mb-0 d-flex align-items-center">
                                <i className="ti ti-grip-vertical me-2" />
                                Created Date
                              </p>
                              <div className="status-toggle">
                                <input
                                  type="checkbox"
                                  id="col-created"
                                  className="check"
                                  checked={visibleColumns.includes("Created")}
                                  onChange={() => handleToggleColumn("Created")}
                                />
                                <label
                                  htmlFor="col-created"
                                  className="checktoggle"
                                ></label>
                              </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between mb-3">
                              <p className="mb-0 d-flex align-items-center">
                                <i className="ti ti-grip-vertical me-2" />
                                Last Activity
                              </p>
                              <div className="status-toggle">
                                <input
                                  type="checkbox"
                                  id="col-last-activity"
                                  className="check"
                                  checked={visibleColumns.includes(
                                    "Last Activity"
                                  )}
                                  onChange={() =>
                                    handleToggleColumn("Last Activity")
                                  }
                                />
                                <label
                                  htmlFor="col-last-activity"
                                  className="checktoggle"
                                ></label>
                              </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between mb-3">
                              <p className="mb-0 d-flex align-items-center">
                                <i className="ti ti-grip-vertical me-2" />
                                Status
                              </p>
                              <div className="status-toggle">
                                <input
                                  type="checkbox"
                                  id="col-status"
                                  className="check"
                                  checked={visibleColumns.includes("Status")}
                                  onChange={() => handleToggleColumn("Status")}
                                />
                                <label
                                  htmlFor="col-status"
                                  className="checktoggle"
                                ></label>
                              </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between mb-3">
                              <p className="mb-0 d-flex align-items-center">
                                <i className="ti ti-grip-vertical me-2" />
                                Action
                              </p>
                              <div className="status-toggle">
                                <input
                                  type="checkbox"
                                  id="col-action"
                                  className="check"
                                  checked={visibleColumns.includes("Action")}
                                  onChange={() => handleToggleColumn("Action")}
                                />
                                <label
                                  htmlFor="col-action"
                                  className="checktoggle"
                                ></label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div className="form-sorts dropdown">
                        <Link
                          to="#"
                          data-bs-toggle="dropdown"
                          data-bs-auto-close="outside"
                        >
                          <i className="ti ti-filter-share" />
                          Filter
                        </Link>
                        <div className="filter-dropdown-menu dropdown-menu  dropdown-menu-md-end p-3">
                          <div className="filter-set-view">
                            <div className="filter-set-head">
                              <h4>
                                <i className="ti ti-filter-share" />
                                Filter
                              </h4>
                            </div>
                            <div className="accordion" id="accordionExample">
                              <div className="filter-set-content">
                                <div className="filter-set-content-head">
                                  <Link
                                    to="#"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo"
                                    aria-expanded="true"
                                    aria-controls="collapseTwo"
                                  >
                                    Name
                                  </Link>
                                </div>
                                <div
                                  className="filter-set-contents accordion-collapse collapse show"
                                  id="collapseTwo"
                                  data-bs-parent="#accordionExample"
                                >
                                  <div className="filter-content-list">
                                    <div className="mb-2 icon-form">
                                      <span className="form-icon">
                                        <i className="ti ti-search" />
                                      </span>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search Name"
                                      />
                                    </div>
                                    <ul>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input
                                              type="checkbox"
                                              defaultChecked
                                            />
                                            <span className="checkmarks" />
                                            Darlee Robertson
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input type="checkbox" />
                                            <span className="checkmarks" />
                                            Sharon Roy
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input type="checkbox" />
                                            <span className="checkmarks" />
                                            Vaughan
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input type="checkbox" />
                                            <span className="checkmarks" />
                                            Jessica
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input type="checkbox" />
                                            <span className="checkmarks" />
                                            Carol Thomas
                                          </label>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              <div className="filter-set-content">
                                <div className="filter-set-content-head">
                                  <Link
                                    to="#"
                                    className="collapsed"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#phone"
                                    aria-expanded="false"
                                    aria-controls="phone"
                                  >
                                    Phone
                                  </Link>
                                </div>
                                <div
                                  className="filter-set-contents accordion-collapse collapse"
                                  id="phone"
                                  data-bs-parent="#accordionExample"
                                >
                                  <div className="filter-content-list">
                                    <ul>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input
                                              type="checkbox"
                                              defaultChecked
                                            />
                                            <span className="checkmarks" />
                                            +1 875455453
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input
                                              type="checkbox"
                                              defaultChecked
                                            />
                                            <span className="checkmarks" />
                                            +1 989757485
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input type="checkbox" />
                                            <span className="checkmarks" />
                                            +1 546555455
                                          </label>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              <div className="filter-set-content">
                                <div className="filter-set-content-head">
                                  <Link
                                    to="#"
                                    className="collapsed"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#email"
                                    aria-expanded="false"
                                    aria-controls="email"
                                  >
                                    Email
                                  </Link>
                                </div>
                                <div
                                  className="filter-set-contents accordion-collapse collapse"
                                  id="email"
                                  data-bs-parent="#accordionExample"
                                >
                                  <div className="filter-content-list">
                                    <ul>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input
                                              type="checkbox"
                                              defaultChecked
                                            />
                                            <span className="checkmarks" />
                                            robertson@example.com
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input
                                              type="checkbox"
                                              defaultChecked
                                            />
                                            <span className="checkmarks" />
                                            sharon@example.com
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input type="checkbox" />
                                            <span className="checkmarks" />
                                            vaughan12@example.com
                                          </label>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              <div className="filter-set-content">
                                <div className="filter-set-content-head">
                                  <Link
                                    to="#"
                                    className="collapsed"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#location"
                                    aria-expanded="false"
                                    aria-controls="location"
                                  >
                                    Location
                                  </Link>
                                </div>
                                <div
                                  className="filter-set-contents accordion-collapse collapse"
                                  id="location"
                                  data-bs-parent="#accordionExample"
                                >
                                  <div className="filter-content-list">
                                    <ul>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input
                                              type="checkbox"
                                              defaultChecked
                                            />
                                            <span className="checkmarks" />
                                            Germany
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input
                                              type="checkbox"
                                              defaultChecked
                                            />
                                            <span className="checkmarks" />
                                            USA
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input type="checkbox" />
                                            <span className="checkmarks" />
                                            Canada
                                          </label>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              <div className="filter-set-content">
                                <div className="filter-set-content-head">
                                  <Link
                                    to="#"
                                    className="collapsed"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#owner"
                                    aria-expanded="false"
                                    aria-controls="owner"
                                  >
                                    Created Date
                                  </Link>
                                </div>
                                <div
                                  className="filter-set-contents accordion-collapse collapse"
                                  id="owner"
                                  data-bs-parent="#accordionExample"
                                >
                                  <div className="filter-content-list">
                                    <ul>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input
                                              type="checkbox"
                                              defaultChecked
                                            />
                                            <span className="checkmarks" />
                                            25 Sep 2023, 12:12 pm
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input
                                              type="checkbox"
                                              defaultChecked
                                            />
                                            <span className="checkmarks" />
                                            27 Sep 2023, 07:40 am
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input type="checkbox" />
                                            <span className="checkmarks" />
                                            29 Sep 2023, 08:20 am
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input type="checkbox" />
                                            <span className="checkmarks" />
                                            02 Oct 2023, 10:10 am
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input type="checkbox" />
                                            <span className="checkmarks" />
                                            17 Oct 2023, 04:25 pm
                                          </label>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              <div className="filter-set-content">
                                <div className="filter-set-content-head">
                                  <Link
                                    to="#"
                                    className="collapsed"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#Status"
                                    aria-expanded="false"
                                    aria-controls="Status"
                                  >
                                    Status
                                  </Link>
                                </div>
                                <div
                                  className="filter-set-contents accordion-collapse collapse"
                                  id="Status"
                                  data-bs-parent="#accordionExample"
                                >
                                  <div className="filter-content-list">
                                    <ul>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input
                                              type="checkbox"
                                              defaultChecked
                                            />
                                            <span className="checkmarks" />
                                            Active
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input
                                              type="checkbox"
                                              defaultChecked
                                            />
                                            <span className="checkmarks" />
                                            Inactive
                                          </label>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="filter-reset-btns">
                              <div className="row">
                                <div className="col-6">
                                  <Link to="#" className="btn btn-light">
                                    Reset
                                  </Link>
                                </div>
                                <div className="col-6">
                                  <Link to="#" className="btn btn-primary">
                                    Filter
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div>
                  {/* /Filter */}
                  {/* Manage Users List */}
                  <div className="table-responsive custom-table">
                    <Table
                      columns={columns}
                      dataSource={filteredUsers}
                      loading={loading}
                      className="custom-table"
                      pagination={{
                        current: currentPage,
                        pageSize: pageSize,
                        showSizeChanger: true,
                        pageSizeOptions: ["10", "20", "50"],
                        onChange: (page: number, size: number) => {
                          setCurrentPage(page);
                          setPageSize(size);
                        },
                      }}
                      scroll={{ x: "max-content" }} // Enables horizontal scroll
                      components={{
                        header: {
                          cell: (props: any) => (
                            <th
                              {...props}
                              style={{
                                ...props.style,
                                position: "sticky",
                                top: 0,
                                zIndex: 2, // Better layering over scrollbars/fixed columns
                                background: "#fff",
                                boxShadow: "inset 0 -1px 0 #f50e0e", // ✅ fix this invalid color
                              }}
                            />
                          ),
                        },
                      }}
                    />
                  </div>
                  <div className="row align-items-center">
                    <div className="col-md-6">
                      <div className="datatable-length" />
                    </div>
                    <div className="col-md-6">
                      <div className="datatable-paginate" />
                    </div>
                  </div>
                  {/* /Manage Users List */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Add User */}
{showAdd && (
  <>
    {/* Backdrop */}
    <div
      className="offcanvas-backdrop fade show"
      onClick={() => setShowAdd(false)}
      style={{ zIndex: 1040 }}
    />

    {/* Panel */}
    <div
      className="offcanvas offcanvas-end offcanvas-large show d-block"
      style={{ visibility: "visible", zIndex: 1050 }}
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="fw-semibold">Add New User</h5>
          <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            onClick={() => setShowAdd(false)}
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          <form>
            <div>
              {/* Basic Info */}
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">
                      Display Name<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">
                      Email <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">
                      Role <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-control"
                      name="role"
                      value={formData.role}
                      onChange={handleSelectChange}
                    >
                      <option value="">Select Role</option>
                      <option value="admin">Admin</option>
                      <option value="user">User</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">
                      Phone number <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="phone_no"
                      value={formData.phone_no}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">
                      Password <span className="text-danger">*</span>
                    </label>
                    <div className="position-relative">
                      <input
                        type={passwordVisibility.password ? "text" : "password"}
                        className="form-control pe-5"
                        name="password"
                        value={formData.password}
                        onChange={handleInputChange}
                        placeholder="Enter password"
                      />
                      <span
                        className="position-absolute end-0 top-50 translate-middle-y me-3 cursor-pointer"
                        onClick={() => togglePasswordVisibility("password")}
                      >
                        <i
                          className={`ti ${
                            passwordVisibility.password
                              ? "ti-eye"
                              : "ti-eye-off"
                          }`}
                        />
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">
                      Client <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-control"
                      name="client_id"
                      value={formData.client_id}
                      onChange={handleSelectChange}
                    >
                      <option value="">Select Client</option>
                      {clients.map((client) => (
                        <option key={client.client_id} value={client.client_id}>
                          {client.client_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="radio-wrap">
                    <label className="col-form-label">Status</label>
                    <div className="d-flex align-items-center">
                      <div className="me-2">
                        <input
                          type="radio"
                          className="status-radio"
                          id="active1"
                          name="status"
                          defaultChecked
                          onChange={() => handleStatusChange(true)}
                        />
                        <label htmlFor="active1">Active</label>
                      </div>
                      <div>
                        <input
                          type="radio"
                          className="status-radio"
                          id="inactive1"
                          name="status"
                          onChange={() => handleStatusChange(false)}
                        />
                        <label htmlFor="inactive1">Inactive</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Basic Info */}
            </div>
           <div className="d-flex justify-content-end mt-4">
                  <button
                    type="button"
                    className="btn btn-light me-2"
                    onClick={() => setShowAdd(false)}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                      handleCreate();
                      setShowAdd(false);
                    }}
                  >
                    Create
                  </button>
                </div>
          </form>
        </div>
      </div>
      </>
)}
      {/* /Add User */}
      {/* Edit User */}
     {showEdit && (
        <>
          {/* Backdrop */}
          <div
            className="offcanvas-backdrop fade show"
            onClick={() => setShowEdit(false)}
            style={{ zIndex: 1040 }}
          />

          {/* Panel */}
          <div
            className="offcanvas offcanvas-end offcanvas-large show d-block"
            style={{ visibility: "visible", zIndex: 1050 }}
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="fw-semibold">Edit User</h5>
          <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
           onClick={() => setShowEdit(false)}
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          <form>
            <div>
              {/* Basic Info */}
              <div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Role <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="role"
                        value={editUserData.role}
                        onChange={handleInputChangeEdit}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* /Basic Info */}
            </div>
            <div className="d-flex align-items-center justify-content-end">
              <Link
                to="#"
                className="btn btn-light me-2"
                onClick={() => setShowEdit(false)}
              >
                Cancel
              </Link>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                      handleUpdateUser();
                      setShowEdit(false);
                    }}
              >
                Save Changes
              </button>
            </div>
          </form>
        </div>
      </div>
      </>
     )}
      {/* /Edit User */}
      {/* Delete User */}
      <div className="modal fade" id="delete_contact" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="text-center">
                <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                  <i className="ti ti-trash-x fs-36 text-danger" />
                </div>
                <h4 className="mb-2">Remove users?</h4>
                <p className="mb-0">Are you sure you want to remove it</p>
                <div className="d-flex align-items-center justify-content-center mt-4">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link
                    to="#"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                    onClick={handleDelete}
                  >
                    Yes, Delete it
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Delete User */}
    </>
  );
};

export default Manageusers;
